import { cn, hasMessage } from '@/lib/utils';
import { MutableRefObject } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen, FileText } from 'lucide-react';

import { FileSpec, useChatMessages } from '@chainlit/react-client';

import WaterMark from '@/components/WaterMark';

import MessageComposer from './MessageComposer';
import MessageLimit from './MessageLimit';
import { useMessageLimit } from '@/hooks/useMessageLimit';

interface Props {
  fileSpec: FileSpec;
  onFileUpload: (payload: File[]) => void;
  onFileUploadError: (error: string) => void;
  autoScrollRef: MutableRefObject<boolean>;
  showIfEmptyThread?: boolean;
}

export default function ChatFooter({ showIfEmptyThread, ...props }: Props) {
  const { messages } = useChatMessages();
  const { isLimitReached } = useMessageLimit();
  const navigate = useNavigate();

  if (!hasMessage(messages) && !showIfEmptyThread) return null;

  return (
    <div className={cn('relative flex flex-col items-center gap-2 w-full')}>
      <MessageLimit context="footer" />
      <MessageComposer {...props} limitReached={isLimitReached} />
      <div className="flex items-center justify-center gap-2 mt-0.5">
        <button
          onClick={() => navigate('/projects')}
          className="flex items-center gap-2 px-6 py-3 rounded-md text-sm text-muted-foreground border border-border hover:bg-accent hover:text-foreground transition-colors"
        >
          <FolderOpen className="h-4 w-4" />
          Mina projekt
        </button>
        <button
          onClick={() => navigate('/mallar')}
          className="flex items-center gap-2 px-6 py-3 rounded-md text-sm text-muted-foreground border border-border hover:bg-accent hover:text-foreground transition-colors"
        >
          <FileText className="h-4 w-4" />
          Avtalsmallar
        </button>
      </div>
    </div>
  );
}
